import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import styled from "styled-components"

const FollowUpButton = styled.a`
  text-decoration: underline !important;
  cursor: pointer;
`

function BasicErrorMessage({
  messageKey, followUpCommand, followUpTextKey, t,
}) {
  return (
    <div>
      {t(messageKey)}
      {followUpCommand &&
        followUpTextKey && (
          <div>
            <FollowUpButton onClick={followUpCommand}>{t(followUpTextKey)}</FollowUpButton>
          </div>
        )}
    </div>
  )
}

BasicErrorMessage.propTypes = {
  messageKey: PropTypes.string.isRequired,
  followUpCommand: PropTypes.func,
  followUpTextKey: PropTypes.string,
}

BasicErrorMessage.defaultProps = {
  followUpCommand: null,
  followUpTextKey: null,
}

export default translate()(BasicErrorMessage)



// WEBPACK FOOTER //
// ./src/components/BasicErrorMessage.jsx